<template>
  <div v-if="showComponent" class="custom-upload">
    <div>
      <image-selector v-model="rightIconImage" />
      <p v-if="!rightIconImage" class="tip-error">请上传文字背景图片</p>
    </div>
    <p class="tip-upload">推荐使用24x24像素的.png图片</p>
  </div>
</template>

<script>
export default {
  name: "customRightIcon",
  data() {
    return {
      rightIconImage: ''
    }
  },
  watch: {
    rightIconImage: {
      deep: true,
      immediate: false,
      handler(newVal) {
        this.$$FormData.right_icon_bg_style = newVal.src || ''
      }
    },
  },
  computed: {
    /**
     * 是否显示组件
     * @returns {boolean}
     */
    showComponent() {
      return !['default'].includes(this.$$FormData.right_icon_style)
    }
  },
  mounted() {
    this.rightIconImage = {
      src: this.$$FormData.right_icon_bg_style
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-upload {
  display: flex;
  align-items: flex-end;
  margin-top: 12px;
  line-height: normal;
  .upload-box,
  .custom-img {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    overflow: hidden;
    color: #155bd4;
    font-size: 20px;
    border: 1px solid #e5e5e5;
    background-color: #f2f4f6;
    cursor: pointer;
    .label-box {
      font-size: 12px;
      margin: 0;
      margin-top: 4px;
    }
  }
  .tip-error {
    margin-top: 5px;
    font-size: 12px;
    color: #d40000;
  }
  .tip-upload {
    color: #969799;
    margin-left: 10px;
    font-size: 12px;
  }
  .custom-img {
    position: relative;
    cursor: auto;
    .img-upload {
      width: 100%;
      height: 100%;
    }
    .change-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      color: #ffffff;
      background-color: rgba(0,0,0,.5);
      cursor: pointer;
    }
  }
}
</style>